import type { GroupBase } from "react-select";
import { SelectItem } from "@ticketingplatform/ui/dist/components/atoms/Fields/Select/types";

import { UseAutoCompleteProps, UseAutoCompleteReturnValue } from "./types";

const useAutoComplete = <
  Option = SelectItem,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props: UseAutoCompleteProps<Option, IsMulti, Group>
): UseAutoCompleteReturnValue<Option, IsMulti, Group> => ({
  $mode: "white",
  ...props,
});

export default useAutoComplete;
